<ng-container *ngIf="data$ | async as data">
  <div *ngIf="data.result" class="h-full price-list-product-detail flex flex-row items-stretch">
    <!-- IMAGES -->
    <cutting-product-images-viewer
      class="cutting-product-images-viewer basis-96"
      [userId]="userId"
      #productImages
      [imagePaths]="data.result.imageList"
      [productId]="data.result.id"
      [priceList]="priceList">
    </cutting-product-images-viewer>
    <!-- END IMAGES -->

    <div class="flex flex-col items-stretch flex-1">
      <!-- ELASTIC -->
      <form name="productForm" [formGroup]="productForm" novalidate class="p-4 flex flex-col space-y-4 items-stretch">
        <!-- INFO -->
        <div class="info flex flex-row space-x-4 items-start">
          <table class="info-table">
            <tbody>
              <tr>
                <td class="secondary-text h3" i18n>Название</td>
                <td>{{ data.result.name }}</td>
              </tr>
              <tr>
                <td class="secondary-text h3" i18n>Артикул</td>
                <td>{{ data.result.article }}</td>
              </tr>
              <tr>
                <td class="secondary-text h3" i18n>Количество</td>
                <td class="flex flex-row space-x-2 items-center">
                  <mat-form-field class="micro-input count-input no-subscript no-label" appearance="outline">
                    <input cslSelectInputsByClick matInput type="number" formControlName="count" />
                    <span matSuffix>{{ data.result.measure }}</span>
                    <mat-error *ngIf="productForm.get('count').hasError('required')" i18n
                      >Поле не должно быть пустым</mat-error
                    >
                    <mat-error
                      *ngIf="
                        !productForm.get('count').hasError('required') && productForm.get('count').hasError('min')
                      ">
                      <span i18n>Минимальное значение:</span>
                      {{ productForm.get('count').errors.min.min }}
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !productForm.get('count').hasError('required') && productForm.get('count').hasError('max')
                      ">
                      <span i18n>Максимальное значение:</span>
                      {{ productForm.get('count').errors.max.max }}
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
              <tr>
                <td class="secondary-text h3" i18n>Примечание</td>
                <td>{{ data.result.note }}</td>
              </tr>
            </tbody>
          </table>
          <!-- END INFO -->

          <!-- IS NOT ELASTIC -->
          <table class="info-table" *ngIf="!data.result.elastic.IsElastic || data.result.processingMode === 0">
            <tbody>
              <tr>
                <td class="secondary-text h3" i18n>Высота</td>
                <td>{{ data.result.height }} <span i18n>мм</span></td>
              </tr>
              <tr>
                <td class="secondary-text h3" i18n>Ширина</td>
                <td>{{ data.result.width }} <span i18n>мм</span></td>
              </tr>
              <tr>
                <td class="secondary-text h3" i18n>Глубина</td>
                <td>{{ data.result.length }} <span i18n>мм</span></td>
              </tr>
            </tbody>
          </table>
          <!-- END IS NOT ELASTIC -->

          <!-- IS ELASTIC -->
          <div
            class="sliders flex flex-col items-stretch"
            *ngIf="data.result.elastic.IsElastic && data.result.processingMode !== 0">
            <div class="flex flex-row space-x-2 items-center">
              <div class="secondary-text h3">
                <span i18n>Высота</span>
                (<span i18n>мм</span>)
              </div>
              <cutting-elastic-value-control
                [constraint]="{
                  step: data.result.elastic.Step.Height,
                  max: data.result.elastic.Max.Height,
                  min: data.result.elastic.Min.Height
                }"
                formControlName="height"
                class="flex-1">
              </cutting-elastic-value-control>
            </div>

            <div class="flex flex-row space-x-2 items-center">
              <div class="secondary-text h3">
                <span i18n>Ширина</span>
                (<span i18n>мм</span>)
              </div>
              <cutting-elastic-value-control
                [constraint]="{
                  step: data.result.elastic.Step.Width,
                  max: data.result.elastic.Max.Width,
                  min: data.result.elastic.Min.Width
                }"
                formControlName="width"
                class="flex-1">
              </cutting-elastic-value-control>
            </div>

            <div class="flex flex-row space-x-2 items-center">
              <div class="secondary-text h3">
                <span i18n>Глубина</span>
                (<span i18n>мм</span>)
              </div>
              <cutting-elastic-value-control
                [constraint]="{
                  step: data.result.elastic.Step.Deep,
                  max: data.result.elastic.Max.Deep,
                  min: data.result.elastic.Min.Deep
                }"
                formControlName="deep"
                class="flex-1">
              </cutting-elastic-value-control>
            </div>
          </div>
          <!-- END IS ELASTIC -->

          <!-- User Properties -->
          <div
            *ngIf="
              (!data.result.elastic.IsElastic || data.result.processingMode === 0) &&
              data.result.userProperties.length > 0
            "
            class="flex flex-col items-stretch">
            <table class="user-properties-table">
              <tbody>
                <tr *ngFor="let item of data.result.userProperties">
                  <td class="px-3 secondary-text" i18n>{{ item.Name }}</td>
                  <td i18n *ngIf="!isUrl(item.Value)"
                    ><div class="note-truncate" [cslOverflowTooltip]="item.Value">
                      {{ item.Value }}
                    </div></td
                  >
                  <td class="px-3" *ngIf="isUrl(item.Value)">
                    <a i18n [href]="item.Value" target="_blank">Перейти</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- END User Properties -->
        </div>
        <!-- END INFO -->

        <!-- User Properties -->
        <div
          *ngIf="
            data.result.elastic.IsElastic && data.result.processingMode !== 0 && data.result.userProperties.length > 0
          "
          class="flex flex-col items-stretch">
          <table class="user-properties-table">
            <tbody>
              <tr *ngFor="let item of data.result.userProperties">
                <td class="px-3 secondary-text" i18n>{{ item.Name }}</td>
                <td i18n *ngIf="!isUrl(item.Value)"
                  ><div class="note-truncate" [cslOverflowTooltip]="item.Value">
                    {{ item.Value }}
                  </div></td
                >
                <td class="px-3" *ngIf="isUrl(item.Value)">
                  <a i18n [href]="item.Value" target="_blank">Перейти</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END User Properties -->

        <!-- <ng-container *ngTemplateOutlet="countControl"></ng-container> -->
      </form>
      <!-- END ELASTIC -->

      <div class="mat-title px-4 m-0" i18n>Элементы</div>

      <mat-divider> </mat-divider>

      <cutting-product-elements
        class="cutting-product-elements"
        fusePerfectScrollbar
        [processingMode]="data.result.processingMode"
        [elements]="data.result.elements"
        (elementsChanged)="onElementsChanged($event)"
        (elementMaterialChanged)="onElementMaterialChanged($event[0], $event[1])"
        [productId]="data.result.id"
        [cuttingOptions]="cuttingOptions"
        [priceListId]="priceList.id"
        [multiplier]="productForm.get('count').value"
        #elementsList>
      </cutting-product-elements>
    </div>
  </div>

  <div *ngIf="!data.error && !data.result">Loading…</div>

  <div *ngIf="data.error">
    {{ data.error | json }}
  </div>
</ng-container>
